export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8751.b9a52e1e.jpg";